import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["onBackClick"];
import { Box, Heading } from '@wix/design-system';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import React from 'react';
import { DomainSearchGateModule } from '../../../module/domainSearchGate.module';
import { HeaderWrapper } from '../HeaderWrapper';
import s from './base44GateHeader.scss';
export const Base44GateHeader = _ref => {
  let onBackClick = _ref.onBackClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const _ref2 = getPremiumEssentialsSafe() ?? {
      siteName: 'your app'
    },
    siteName = _ref2.siteName;
  return /*#__PURE__*/React.createElement(Box, _extends({
    direction: "vertical",
    align: "center",
    width: "100%",
    gap: "SP8"
  }, props), /*#__PURE__*/React.createElement(HeaderWrapper, {
    onBackClick: onBackClick
  }, /*#__PURE__*/React.createElement(Heading, {
    size: "extraLarge",
    className: s.siteGateHeaderTitle
  }, t('domains_search_gate.base44.gate.title', {
    appName: siteName
  }))));
};
//# sourceMappingURL=Base44GateHeader.js.map